// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__VPMm+","card-grid-verticals":"verticals-page_card-grid-verticals__ygktO","headerText":"verticals-page_headerText__yMVLF"};